import React from 'react';

/** Small launch-timing pill for chapter cards (landing) and /chapter/:id hero. */
export default function ChapterLaunchBadge({ children, tone = 'card' }) {
  if (children == null || children === '') return null;

  const base = {
    display: 'inline-block',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.04em',
    padding: '4px 10px',
    borderRadius: 999,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    lineHeight: 1.3,
  };

  if (tone === 'hero') {
    return (
      <span
        style={{
          ...base,
          background: 'rgba(255,255,255,0.22)',
          color: 'rgba(255,255,255,0.98)',
          border: '1px solid rgba(255,255,255,0.38)',
        }}
      >
        {children}
      </span>
    );
  }

  return (
    <span
      style={{
        ...base,
        background: 'rgb(255, 253, 249)',
        color: 'rgb(95, 94, 90)',
        border: '1px solid rgb(232, 224, 216)',
      }}
    >
      {children}
    </span>
  );
}
